import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "nav-drawer-icon-wrap" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "nav-drawer-icon-wrap" }

import { storeToRefs } from 'pinia';
import { useUserStore } from '@/store/useUser';
import { drawer } from '@/store/stateless/drawer';
import router from '@/router';


export default /*@__PURE__*/_defineComponent({
  __name: 'navDrawer',
  setup(__props) {

const user = useUserStore();
const { currentUser, isLoggedIn } = storeToRefs(user);
const { signout } = useUserStore();
const doSignout = async () => {
  try {
    await signout();
    router.push({ name: 'Login' });
  } catch (error) {
    // error;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_list, null, {
      default: _withCtx(() => [
        (_unref(isLoggedIn))
          ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 0,
              "prepend-avatar": _unref(currentUser).photoURL,
              title: _unref(currentUser).displayName,
              subtitle: _unref(currentUser).email
            }, null, 8, ["prepend-avatar", "title", "subtitle"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_divider),
    _createVNode(_component_v_list, {
      density: "compact",
      nav: "",
      class: "nav-drawer-list"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(drawer).lis, (li, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (li.isNavigation)
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 0,
                  title: li.title,
                  to: { name: li.navigation },
                  class: "nav-drawer-item"
                }, {
                  prepend: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      (li.iconSrc)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: li.iconSrc,
                            alt: "",
                            class: "nav-drawer-custom-icon"
                          }, null, 8, _hoisted_2))
                        : (_openBlock(), _createBlock(_component_v_icon, {
                            key: 1,
                            size: "24"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(li.icon), 1)
                            ]),
                            _: 2
                          }, 1024))
                    ])
                  ]),
                  _: 2
                }, 1032, ["title", "to"]))
              : (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 1,
                  title: li.title,
                  class: "nav-drawer-item",
                  onClick: doSignout
                }, {
                  prepend: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_v_icon, { size: "24" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(li.icon), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 2
                }, 1032, ["title"]))
          ], 64))
        }), 128))
      ]),
      _: 1
    })
  ], 64))
}
}

})